import { IDealDemandPartner } from '~/src/dash/api/deal-demand-partner/deal-demand-partner-models';
import { addDomainAndTokenToUrl, restDelete, restGet, restPost } from '~/src/dash/api/rest';

export async function createDealDemandPartner(
  name: string,
): Promise<[IDealDemandPartner | undefined, string | undefined]> {
  const reqUrl = addDomainAndTokenToUrl('/deal_demand_partner');

  try {
    return [
      (
        await restPost<IDealDemandPartner>(reqUrl, {
          Name: name,
        })
      ).parsedBody,
      undefined,
    ];
  } catch (e) {
    return [undefined, e];
  }
}

export async function getDealDemandPartners(): Promise<
  [IDealDemandPartner[] | undefined, string | undefined]
> {
  const reqUrl = addDomainAndTokenToUrl('/deal_demand_partners');

  try {
    return [(await restGet<IDealDemandPartner[]>(reqUrl)).parsedBody, undefined];
  } catch (e) {
    return [undefined, e];
  }
}

export async function deleteDealDemandPartner(
  partnerID: string,
): Promise<[null | undefined, string | undefined]> {
  const reqUrl = addDomainAndTokenToUrl('/deal_demand_partner/' + partnerID);

  try {
    return [(await restDelete<null>(reqUrl, null)).parsedBody, undefined];
  } catch (e) {
    return [null, e];
  }
}
